import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import FlashMicroPythonCard from './setup-esp32-firmware/FlashMicroPythonCard';
import { checkWebSerialSupport } from './setup-esp32-firmware/WebSerialUtils';

function SetupESP32FlashMicroPython(props) {
  if (checkWebSerialSupport()) {
    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <FlashMicroPythonCard></FlashMicroPythonCard>
        </Col>
      </Row>
    );
  } else {
    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className="text-center">
          <Alert variant="danger">
            ESP32 browser-based support only works on Google Chrome browsers!
            <br />
            Please re-try on a Chrome web browser.
          </Alert>
        </Col>
      </Row>
    );
  }
}

export default SetupESP32FlashMicroPython;
